import { request } from './http';
import type { AdminLoginRequest, AdminLoginResponse, AdminProfile } from '@/types/admin';

export const adminAuthApi = {
  login(payload: AdminLoginRequest) {
    return request<AdminLoginResponse>({
      url: '/admin/auth/login',
      method: 'POST',
      data: payload,
    });
  },
  logout() {
    return request<void>({ url: '/admin/auth/logout', method: 'POST' });
  },
  me() {
    return request<AdminProfile>({ url: '/admin/auth/me', method: 'GET' });
  },
};
